// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"9dadc32d","311":"7eb11bf1","375":"444ca3b8","791":"69b30f7e","900":"ddb49bb3"}[chunkId] + ".chunk.js";
};